import styled from "styled-components";

const Wrapper = styled.article`
  display: flex;
  flex-direction: column;
`;

export default Wrapper;
